<script setup></script>

<template>
  <svg height="24" fill="currentColor" width="24" xmlns="http://www.w3.org/2000/svg">
    <polygon points="16,9 12,13 8,9 6.2,10.8 12,16.6 17.8,10.8" />
  </svg>
</template>
